import {ConfigComponenteKit} from '../../../../server/domain/kit/ConfigComponenteKit';
import {QuantidadeComponenteKit} from '../../../../server/domain/kit/QuantidadeComponenteKit';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { ProdutosV2FacadeService } from '../produtos-v2.facade';
import { ConstantsService } from '../../fidelidade/ConstantsService';
import { LimiteAdicionais } from '../../../../server/domain/delivery/LimiteAdicionais';
import {
  ChoiceGroupVM,
  ChoiceOptionVM,
  LibraryGroupVM,
  LibraryProductGroupVM,
  ProductEditorVM,
  ProductTypeV2
} from '../produtos-v2.models';

type AdicionalOptionModeV2 = 'review' | 'activation' | 'batch-price';
type AdicionalOptionSortV2 = 'name-asc' | 'price-asc' | 'price-desc';
type BatchPriceAdjustMode = 'fixed' | 'increment' | 'percent';
type BatchPriceAdjustDirection = 'increase' | 'decrease';
type SaveFooterState = 'hidden' | 'dirty' | 'saving' | 'saved';
type CreationPhase = 'config' | 'full';
type AdicionalWizardMode = 'choice' | 'create' | 'library';
type LibraryHintMode = 'link' | 'duplicate';
type AdicionalSectionKey = 'identity' | 'rules' | 'quantity' | 'options' | 'summary';
type EditOptionSheetTab = 'dados' | 'tabela-precos';
type AdicionalDraftErrors = { name?: string; options?: string };

@Component({
  selector: 'app-tela-editor-adicional-v2',
  templateUrl: './tela-editor-adicional-v2.component.html',
  styleUrls: ['./tela-editor-adicional-v2.component.scss']
})
export class TelaEditorAdicionalV2Component implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() editor!: ProductEditorVM;
  @Input() empresa: any;
  @Input() podeEditar = true;
  @Input() podeEditarPrecos = true;
  @Input() podeEditarDisponibilidade = true;
  @Input() podeEditarExibicaoOpcoes = true;
  @Input() groupId: number | string | null = null;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() startWithLibrary = false;
  /** Pula a escolha "do zero / da biblioteca" e abre direto o formulário de criação. */
  @Input() startWithCreate = false;
  @Input() crossSellProductId: number | null = null;
  @Input() standalone = false;
  @Input() requestedOptionMode: AdicionalOptionModeV2 | null = null;

  @Output() closeRequested = new EventEmitter<void>();
  @Output() groupSaved = new EventEmitter<ChoiceGroupVM>();
  @Output() groupDeleted = new EventEmitter<ChoiceGroupVM>();
  @Output() groupDuplicated = new EventEmitter<void>();
  @Output() libraryGroupsLinked = new EventEmitter<number>();
  @Output() libraryRequested = new EventEmitter<void>();
  @Output() actionBarStateChange = new EventEmitter<{
    creationPhase: CreationPhase;
    saveFooterState: SaveFooterState;
  }>();

  @ViewChild('optionNameInput') optionNameInput!: ElementRef<HTMLInputElement>;
  @ViewChild('editingOptionNameInput') editingOptionNameInput?: ElementRef<HTMLInputElement>;

  groupDraft: ChoiceGroupVM | null = null;
  private snapshot = '';
  isDirty = false;
  saveFooterState: SaveFooterState = 'hidden';
  creationPhase: CreationPhase = 'config';
  wizardMode: AdicionalWizardMode = 'choice';
  creationErrors: AdicionalDraftErrors = {};
  choiceSelection: 'create' | 'library' = 'create';
  isMobile = false;
  groupFormCollapsedMobile = false;
  quantityModeRolloutEnabled = true;
  isEmbeddedContext = false;
  librarySearch = '';
  libraryFilter = 'Todos';
  libraryLoading = false;
  libraryItems: LibraryGroupVM[] = [];
  choiceProbing = false;
  choiceSkipped = false;
  selectedLibraryGroup: LibraryGroupVM | null = null;
  librarySelection: Record<string, boolean> = {};
  libraryLinking = false;
  libraryHintMode: LibraryHintMode = 'link';
  libraryMobilePreviewExpanded = false;
  libraryExpandedProducts: Record<string | number, boolean> = {};
  sectionExpanded: Record<AdicionalSectionKey, boolean> = {
    identity: true,
    rules: true,
    quantity: true,
    options: true,
    summary: false
  };

  // Option browser state
  optionMode: AdicionalOptionModeV2 = 'review';
  optionSearch = '';
  optionSort: AdicionalOptionSortV2 = 'name-asc';

  // Add option
  newOptionName = '';
  newOptionPrice = '';

  // Edit sheet
  editSheetOpen = false;
  editingOptionId: string | number | null = null;
  editingOptionName = '';
  editingOptionPrice: number | null = null;
  editingOptionPdv = '';
  editingOptionDescription = '';
  editingOptionActive = true;
  editingOptionLinkImagem: string | null = null;
  editingOptionQtdeMaxima: number | null = null;
  editingOptionDisponivelParaDelivery = true;
  editingOptionDisponivelNaMesa = true;
  editingOptionUploadingImage = false;
  editSheetAdvancedOpen = false;
  editSheetActiveTab: EditOptionSheetTab = 'dados';
  temModuloTabelaPrecos = false;

  // Batch
  batchSelection: Record<string, boolean> = {};
  batchSheetOpen = false;
  batchAdjustMode: BatchPriceAdjustMode = 'increment';
  batchAdjustDirection: BatchPriceAdjustDirection = 'increase';
  batchAdjustValue = '';

  // Delete dialog
  showDeleteDialog = false;

  // Edit hint
  showEditHint = true;

  // Shared product names
  sharedProductNames: string[] = [];

  // Private
  private optionRuntimeKeys = new WeakMap<ChoiceOptionVM, string>();
  private optionRuntimeKeySequence = 0;
  private savedTimer: any = null;
  private groupSaveTimer: any = null;
  private addingOption = false;
  private crossSellPrefillSequence = 0;
  private moduloTabelaPrecosSubscription?: Subscription;

  constructor(
    private facade: ProdutosV2FacadeService,
    private notificationService: NotificationService,
    private elementRef: ElementRef,
    private httpClient: HttpClient,
    private constantsService: ConstantsService
  ) {
    this.handleResize();
  }

  ngOnInit(): void {
    this.initDraft();
    this.moduloTabelaPrecosSubscription = this.constantsService.moduloTabelaPrecos$.subscribe((ativo) => {
      this.temModuloTabelaPrecos = !!ativo;
      if (!this.temModuloTabelaPrecos && this.editSheetActiveTab === 'tabela-precos') {
        this.editSheetActiveTab = 'dados';
      }
    });
  }

  ngAfterViewInit(): void {
    this.updateEmbeddedContext();
    this.scrollToTop();
  }

  private updateEmbeddedContext(): void {
    const el = this.elementRef.nativeElement as HTMLElement;
    this.isEmbeddedContext = !!el.closest('.pv2-editor-page');
  }

  private emitActionBarState(): void {
    this.actionBarStateChange.emit({
      creationPhase: this.creationPhase,
      saveFooterState: this.saveFooterState
    });
  }

  scrollToOptionInput(): void {
    if (!this.optionNameInput) return;
    const input = this.optionNameInput.nativeElement;
    const section = input.closest('.pv2-add-option-section');
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (section) {
      section.classList.remove('is-highlight');
      void (section as HTMLElement).offsetWidth;
      section.classList.add('is-highlight');
    }
    setTimeout(() => input.focus(), 350);
  }

  private scrollToTop(): void {
    const el = this.elementRef.nativeElement as HTMLElement;
    const scrollParent = el.closest('.pv2-editor-drawer')
      || el.closest('.pv2-editor-page')
      || el.closest('.pv2-editor-canvas');
    if (scrollParent) {
      scrollParent.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['groupId'] || changes['mode'] || changes['editor'] || changes['startWithLibrary'] || changes['startWithCreate'] || changes['crossSellProductId'] || changes['requestedOptionMode']) {
      this.initDraft();
      setTimeout(() => this.scrollToTop(), 0);
    }
  }

  ngOnDestroy(): void {
    if (this.savedTimer) clearTimeout(this.savedTimer);
    // Última rede de proteção: dispara (sem esperar) o que ficou no debounce.
    void this.flushPendingSave();
    this.moduloTabelaPrecosSubscription?.unsubscribe();
  }

  @HostListener('window:resize')
  handleResize() {
    this.isMobile = window.innerWidth < 1024;
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardSave(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 's') {
      event.preventDefault();
      if (event.shiftKey) {
        this.onSaveAndClose();
      } else {
        this.onSave();
      }
    }
  }

  // ────────────────────────────── Getters ──────────────────────────────

  get focusedGroup(): ChoiceGroupVM | null {
    if (!this.editor || this.groupId == null) return null;
    return this.editor.groups.find((g) => String(g.id) === String(this.groupId)) || null;
  }

  get isActivationMode(): boolean {
    return this.optionMode === 'activation';
  }

  get isReviewMode(): boolean {
    return this.optionMode === 'review';
  }

  get editingOptionTargetId(): number | null {
    const id = Number(this.editingOptionId);
    return id && !isNaN(id) ? id : null;
  }

  get isBatchPriceMode(): boolean {
    return this.optionMode === 'batch-price';
  }

  get modeThemeClass(): string {
    switch (this.optionMode) {
      case 'activation': return 'is-mode-onoff';
      case 'review': return 'is-mode-editar';
      case 'batch-price': return 'is-mode-lote';
      default: return '';
    }
  }

  get groupActiveCount(): number {
    const group = this.groupDraft;
    return (group?.options || []).filter((o) => o.active !== false).length;
  }

  get groupTotalCount(): number {
    return this.groupDraft?.options?.length || 0;
  }

  get batchSelectedCount(): number {
    return Object.keys(this.batchSelection).filter((key) => this.batchSelection[key]).length;
  }

  get batchSelectedOptions(): ChoiceOptionVM[] {
    if (!this.groupDraft) return [];
    return (this.groupDraft.options || []).filter((option) => this.isBatchOptionSelected(option));
  }

  batchPreviewPrice(option: ChoiceOptionVM): number {
    const rawValue = this.parseOptionMoney(this.batchAdjustValue);
    switch (this.batchAdjustMode) {
      case 'fixed':
        return rawValue;
      case 'increment':
        return Math.max(0, Number(option.price || 0) + rawValue);
      case 'percent':
        return Math.max(0, Math.round(Number(option.price || 0) * (1 + rawValue / 100) * 100) / 100);
      default:
        return rawValue;
    }
  }

  get batchAdjustHint(): string {
    switch (this.batchAdjustMode) {
      case 'fixed':
        return `Todas as ${this.batchSelectedCount} opções terão este preço`;
      case 'increment':
        return 'Valor será somado (ou subtraído) do preço atual de cada opção';
      case 'percent':
        return 'Percentual aplicado sobre o preço atual de cada opção';
      default:
        return '';
    }
  }
  get batchValuePrefix(): string {
    switch (this.batchAdjustMode) {
      case 'increment':
        return '+/-';
      case 'percent':
        return '%';
      case 'fixed':
      default:
        return 'R$';
    }
  }

  get batchValueLabel(): string {
    switch (this.batchAdjustMode) {
      case 'increment':
        return 'Ajuste de valor';
      case 'percent':
        return 'Reajuste percentual';
      case 'fixed':
      default:
        return 'Preço final';
    }
  }

  get batchHelperText(): string {
    switch (this.batchAdjustMode) {
      case 'increment':
        return 'Escolha Aumentar ou Reduzir e informe o valor a aplicar sobre o preço atual.';
      case 'percent':
        return 'Escolha Aumentar ou Reduzir e informe a porcentagem a aplicar sobre o valor atual.';
      case 'fixed':
      default:
        return 'Todas as opções selecionadas passarão a ter exatamente este preço.';
    }
  }

  get batchApplyButtonLabel(): string {
    return `Aplicar preço em ${this.batchSelectedCount} ${this.batchSelectedCount === 1 ? 'opção' : 'opções'}`;
  }

  get batchPreviewOptions(): ChoiceOptionVM[] {
    const group = this.groupDraft;
    if (!group) return [];

    const selected = (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option));

    if (selected.length) return selected;

    return group.options || [];
  }

  get batchPreviewMetaLabel(): string {
    if (this.batchSelectedCount) {
      return `Mostrando ${this.batchPreviewOptions.length} de ${this.batchSelectedCount}`;
    }

    const total = this.groupDraft?.options?.length || 0;
    return total
      ? `Exibindo ${this.batchPreviewOptions.length} opções como amostra`
      : 'Sem opções para visualizar';
  }

  get hasBatchAdjustValue(): boolean {
    return String(this.batchAdjustValue || '').trim().length > 0;
  }
  private filteredOptionsCacheKey = '';
  private filteredOptionsCache: ChoiceOptionVM[] = [];

  get filteredOptions(): ChoiceOptionVM[] {
    const group = this.groupDraft;
    if (!group) return [];

    const options = group.options || [];
    const term = this.optionSearch.trim().toLowerCase();
    // getter roda a cada ciclo de change detection; só refaz filtro+ordenação quando algo relevante mudou
    const key = [this.optionSort, term, options.length,
      options.map((o) => `${o.name || ''}\u0001${o.price ?? ''}`).join('\u0002')].join('\u0003');
    if (key === this.filteredOptionsCacheKey) {
      return this.filteredOptionsCache;
    }

    const filtered = options.filter((option) => {
      return !term || (option.name || '').toLowerCase().includes(term);
    });

    this.filteredOptionsCacheKey = key;
    this.filteredOptionsCache = filtered.sort((left, right) => {
      if (this.optionSort === 'price-asc') {
        return Number(left.price || 0) - Number(right.price || 0)
          || String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
      }
      if (this.optionSort === 'price-desc') {
        return Number(right.price || 0) - Number(left.price || 0)
          || String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
      }
      return String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
    });
    return this.filteredOptionsCache;
  }

  /** Resolve a opção a partir do chip ancorado pela tooltip única do container. */
  optionForTooltipAnchor(anchor: any): ChoiceOptionVM | null {
    const el: HTMLElement | undefined = anchor?.nativeElement || anchor;
    const idx = Number(el?.dataset?.optionIdx);
    return Number.isFinite(idx) ? (this.filteredOptions[idx] || null) : null;
  }

  get showSearchAndSort(): boolean {
    return (this.groupDraft?.options?.length || 0) > 2;
  }

  get hasOptions(): boolean {
    return (this.groupDraft?.options?.length || 0) > 0;
  }

  get erroLimiteAdicionais(): string | null {
    if (!this.groupDraft || this.groupDraft.kind !== 'adicional') return null;
    return LimiteAdicionais.obtenhaErro(this.editor?.raw?.camposAdicionais, {
      id: this.groupDraft.raw?.id,
      tipo: this.groupDraft.type === 'single' ? 'escolha-simples' : 'multipla-escolha'
    });
  }

  get isChoiceMode(): boolean {
    return this.wizardMode === 'choice';
  }

  get isCreateMode(): boolean {
    return this.wizardMode === 'create';
  }

  get isLibraryMode(): boolean {
    return this.wizardMode === 'library';
  }

  get filteredLibraryItems(): LibraryGroupVM[] {
    const term = this.librarySearch.trim().toLowerCase();
    return this.libraryItems.filter((item) => {
      const matchesSearch = !term
        || item.name.toLowerCase().includes(term)
        || (item.sourceProductName || '').toLowerCase().includes(term)
        || (item.sharedProductNames || []).some((n) => n.toLowerCase().includes(term));
      if (!matchesSearch) return false;
      if (this.libraryFilter === 'Compartilhados') return item.sharedCount > 1;
      if (this.libraryFilter === 'Exclusivos') return item.sharedCount === 1;
      return true;
    });
  }

  /**
   * `filteredLibraryProductGroups` monta objetos novos a cada leitura, e o Angular
   * lê o getter a cada detecção de mudança. Sem `trackBy` o *ngFor via tudo como
   * item novo e refazia o DOM da biblioteca inteira a cada ciclo — era isso que
   * fazia os cartões piscarem.
   */
  trackByLibraryProductGroup(_: number, group: LibraryProductGroupVM): any {
    return group.productId;
  }

  trackByLibraryItem(_: number, item: LibraryGroupVM): any {
    return item.id ?? item.name;
  }

  get filteredLibraryProductGroups(): LibraryProductGroupVM[] {
    const filtered = this.filteredLibraryItems;
    const term = this.librarySearch.trim().toLowerCase();
    const shared: LibraryGroupVM[] = [];
    const byProduct = new Map<number, { name: string; type: ProductTypeV2; items: LibraryGroupVM[] }>();

    for (const item of filtered) {
      if (item.sharedCount > 1) {
        shared.push(item);
      } else {
        const pid = item.sourceProductId || 0;
        if (!byProduct.has(pid)) {
          byProduct.set(pid, {
            name: item.sourceProductName || 'Produto sem nome',
            type: (item.sourceProductType || 'normal') as ProductTypeV2,
            items: []
          });
        }
        byProduct.get(pid)!.items.push(item);
      }
    }

    const groups: LibraryProductGroupVM[] = [];

    if (shared.length > 0) {
      groups.push({
        productId: -1,
        productName: 'Compartilhados',
        productType: 'normal',
        adicionais: shared,
        expanded: this.libraryExpandedProducts[-1] ?? true
      });
    }

    const productEntries = Array.from(byProduct.entries())
      .sort(([, a], [, b]) => a.name.localeCompare(b.name, 'pt-BR'));

    for (const [pid, data] of productEntries) {
      groups.push({
        productId: pid,
        productName: data.name,
        productType: data.type,
        adicionais: data.items.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')),
        expanded: this.libraryExpandedProducts[pid] ?? !!term
      });
    }

    return groups;
  }

  get totalFilteredAdicionais(): number {
    return this.filteredLibraryProductGroups.reduce((sum, g) => sum + g.adicionais.length, 0);
  }

  get selectedLibraryGroups(): LibraryGroupVM[] {
    return this.libraryItems.filter((item) => !!this.librarySelection[String(item.id)]);
  }

  get selectedLibraryCount(): number {
    return this.selectedLibraryGroups.length;
  }

  toggleProductGroup(productId: number): void {
    this.libraryExpandedProducts[productId] = !this.libraryExpandedProducts[productId];
  }

  getProductTypeIcon(type: string): string {
    switch (type) {
      case 'pizza': return 'fa-pizza-slice';
      case 'brindefidelidade': return 'fa-gift';
      default: return 'fa-box';
    }
  }

  get editorPlaceholder(): string {
    if (!this.editor) return '\uD83C\uDF7D\uFE0F';
    return this.editor.emoji || (this.editor.type === 'pizza' ? '\uD83C\uDF55' : '\uD83C\uDF7D\uFE0F');
  }

  get headerTitle(): string {
    if (this.isCreateMode && this.mode === 'edit') {
      return 'Editar adicional';
    }
    return this.groupDraft?.name || 'Novo adicional';
  }

  get headerSubtitle(): string {
    const parts: string[] = [];
    if (this.editor?.name) parts.push(this.editor.name);
    if (this.editor?.category) parts.push(this.editor.category);
    if (this.groupDraft && this.groupDraft.options.length) {
      parts.push(`${this.groupDraft.options.length} opções`);
    }
    return parts.join(' • ');
  }

  get heroStatusLabel(): string {
    if (this.saveFooterState === 'saving') return 'Salvando...';
    if (this.saveFooterState === 'saved') return 'Salvo';
    if (this.isDirty) return 'Alterações pendentes';
    if (this.mode === 'create') return 'Rascunho';
    return 'Salvo';
  }

  get podeEditarAlgumaOpcao(): boolean {
    return this.podeEditar || this.podeEditarPrecos || this.podeEditarDisponibilidade
      || this.podeEditarExibicaoOpcoes;
  }

  get previewTitle(): string {
    if (this.isLibraryMode && this.selectedLibraryGroup) {
      return this.selectedLibraryGroup.name || 'Adicional';
    }
    return this.groupDraft?.name?.trim() || 'Novo adicional';
  }

  get previewRequired(): boolean {
    if (this.isLibraryMode && this.selectedLibraryGroup) {
      return Number(this.selectedLibraryGroup.min || 0) > 0;
    }
    return Number(this.groupDraft?.min || 0) > 0;
  }

  get previewSelectionText(): string {
    const type = this.isLibraryMode && this.selectedLibraryGroup
      ? this.selectedLibraryGroup.type
      : this.groupDraft?.type;
    const min = this.isLibraryMode && this.selectedLibraryGroup
      ? (this.selectedLibraryGroup.min ?? 0)
      : (this.groupDraft?.min ?? 0);
    const required = Number(min || 0) > 0;
    const max = this.isLibraryMode && this.selectedLibraryGroup
      ? (this.selectedLibraryGroup.max ?? 1)
      : (this.groupDraft?.max ?? 1);

    return this.formatSelectionRule(type, required, min, max);
  }

  get previewOptions(): string[] {
    if (this.isLibraryMode && this.selectedLibraryGroup) {
      return this.selectedLibraryGroup.previewOptions || [];
    }

    return (this.groupDraft?.options || [])
      .filter((option) => option.active !== false)
      .map((option) => option.name)
      .filter((name) => !!name)
      .slice(0, 3);
  }

  get previewMultiplicaQuantidadeProduto(): boolean {
    if (this.isLibraryMode && this.selectedLibraryGroup) {
      return this.selectedLibraryGroup.multiplicaQuantidadeProduto !== false;
    }

    return this.groupDraft?.multiplicaQuantidadeProduto !== false;
  }

  get previewHintTitle(): string {
    if (!this.isLibraryMode) {
      return this.hasSharedUsageInOtherProducts ? 'Compartilhado' : 'Visão do cliente';
    }

    if (this.libraryHintMode === 'duplicate') return 'Cópia independente';
    if (!this.selectedLibraryGroup) return 'Como funciona';
    if (this.selectedLibraryGroup.sharedCount === 0) return 'Sem vínculo';
    if (this.selectedLibraryGroup.sharedCount === 1) return 'Vai se tornar compartilhado';
    return 'Compartilhado';
  }

  get previewHintText(): string {
    if (!this.isLibraryMode) {
      if (this.hasSharedUsageInOtherProducts) {
        return this.getSharedWarningSupportText();
      }
      return 'A visualização reage em tempo real e mostra como este adicional aparece para o cliente.';
    }

    if (this.libraryHintMode === 'duplicate') {
      return 'Ao duplicar, este produto recebe uma cópia independente. As edições não afetam o adicional original.';
    }

    if (!this.selectedLibraryGroup) {
      return 'Marque um ou mais adicionais para vinculá-los de uma vez. Selecione a linha para ver os detalhes.';
    }

    if (this.selectedLibraryGroup.sharedCount === 0) {
      return 'Este grupo ainda não está vinculado a nenhum produto. O primeiro vínculo será criado agora.';
    }

    if (this.selectedLibraryGroup.sharedCount === 1) {
      const productName = this.selectedLibraryGroup.sourceProductName || this.selectedLibraryGroup.sharedProductNames?.[0] || 'outro produto';
      return `Hoje este grupo é exclusivo de ${productName}. Ao vinculá-lo, passará a ser compartilhado entre 2 produtos.`;
    }

    return `Este grupo já é compartilhado entre ${this.selectedLibraryGroup.sharedCount} produtos. Alterações futuras serão refletidas em todos eles.`;
  }

  get libraryMobilePreviewLabel(): string {
    return this.selectedLibraryGroup?.name?.trim() || 'Selecione um adicional para visualizar';
  }

  get sharedWarningSupportText(): string {
    return this.getSharedWarningSupportText();
  }

  get hasSharedUsageInOtherProducts(): boolean {
    return !!this.groupDraft?.shared && Number(this.groupDraft?.sharedCount || 0) > 1;
  }

  get deleteDialogTitle(): string {
    return this.groupDraft?.shared ? 'Remover adicional deste produto?' : 'Excluir adicional?';
  }

  get deleteDialogBody(): string {
    if (this.groupDraft?.shared) {
      return 'Esse adicional está compartilhado. Ao remover, ele será desvinculado apenas deste produto.';
    }

    return 'Essa ação é irreversível. Todas as opções vinculadas a este adicional serão removidas permanentemente.';
  }

  get deleteActionLabel(): string {
    return this.groupDraft?.shared ? 'Remover deste produto' : 'Excluir';
  }

  get identitySectionSummary(): string {
    const name = this.groupDraft?.name?.trim() || 'Sem nome';
    const type = this.getTypeLabel(this.groupDraft?.type);
    return `${name} • ${type}`;
  }

  get rulesSectionSummary(): string {
    const required = Number(this.groupDraft?.min || 0) > 0 ? 'Obrigatório' : 'Opcional';
    const quantity = this.groupDraft?.type === 'single'
      ? '1 seleção'
      : `${this.groupDraft?.min ?? 0}–${this.groupDraft?.max ?? 1}`;
    return `${required} • ${quantity} • ${this.getChargeTypeLabel(this.groupDraft?.chargeType)}`;
  }

  get quantitySectionSummary(): string {
    return this.getQuantityModeChip(this.groupDraft?.multiplicaQuantidadeProduto);
  }

  get optionsSectionSummary(): string {
    const total = this.groupDraft?.options?.length || 0;
    return `${total} ${total === 1 ? 'opção' : 'opções'}`;
  }

  get summarySectionSummary(): string {
    if (!this.groupDraft?.shared) {
      return 'Só neste produto';
    }

    const sharedCount = Number(this.groupDraft?.sharedCount || 0);
    if (sharedCount > 1) {
      return `Compartilhado em ${sharedCount} produtos`;
    }

    return 'Compartilhado';
  }

  // ────────────────────────────── Init ──────────────────────────────

  private initDraft(): void {
    if (this.mode === 'edit' && this.groupId != null) {
      const group = this.focusedGroup;
      if (group) {
        this.groupDraft = this.cloneGroup(group);
        this.creationPhase = 'full';
        this.wizardMode = 'create';
      } else {
        this.groupDraft = this.buildEmptyGroupDraft();
        this.creationPhase = 'config';
        this.wizardMode = this.startWithLibrary ? 'library' : 'choice';
      }
    } else {
      this.groupDraft = this.buildEmptyGroupDraft();
      this.creationPhase = this.startWithCreate && !this.startWithLibrary ? 'full' : 'config';
      this.wizardMode = this.startWithLibrary ? 'library' : (this.startWithCreate ? 'create' : 'choice');
    }

    this.creationErrors = {};
    this.choiceSkipped = this.startWithCreate && !this.startWithLibrary;
    this.choiceSelection = this.startWithLibrary ? 'library' : 'create';
    this.librarySearch = '';
    this.libraryFilter = 'Todos';
    this.libraryHintMode = 'link';
    this.selectedLibraryGroup = null;
    this.librarySelection = {};
    this.libraryLinking = false;
    this.libraryMobilePreviewExpanded = false;
    this.sharedProductNames = [];
    if (this.isLibraryMode) {
      void this.loadLibrary();
    } else if (this.isChoiceMode) {
      void this.probeLibraryForChoice();
    }
    if (this.mode === 'edit' && this.groupDraft?.id) {
      void this.loadSharedProductNames();
    }

    this.takeSnapshot();
    this.isDirty = false;
    this.saveFooterState = 'hidden';
    this.optionMode = this.requestedOptionMode || 'review';
    this.optionSearch = '';
    this.optionSort = 'name-asc';
    this.batchSelection = {};
    this.editSheetOpen = false;
    this.batchSheetOpen = false;
    this.showDeleteDialog = false;
    this.newOptionName = '';
    this.newOptionPrice = '';
    this.resetSectionExpansion();
    this.emitActionBarState();
    void this.preenchaSugestaoCrossSell();
  }

  private buildEmptyGroupDraft(): ChoiceGroupVM {
    return {
      id: null,
      name: '',
      type: 'single',
      required: false,
      min: 0,
      max: 1,
      chargeType: 'soma',
      multiplicaQuantidadeProduto: true,
      shared: false,
      sharedCount: 0,
      order: this.editor?.groups?.length || 0,
      kind: 'adicional',
      description: 'Selecione até 1 opção',
      options: []
    };
  }

  private async preenchaSugestaoCrossSell(): Promise<void> {
    const sequencia = ++this.crossSellPrefillSequence;
    const idProduto = Number(this.crossSellProductId || 0);
    if (this.mode !== 'create' || !idProduto || !this.groupDraft || !this.empresa) return;

    try {
      const produto = await this.facade.carregueProduto(this.empresa, idProduto);
      if (sequencia !== this.crossSellPrefillSequence || this.mode !== 'create' || !this.groupDraft) return;

      const opcaoRaw: any = {
        nova: true,
        nome: produto.name,
        descricao: produto.description || '',
        valor: Number(produto.basePrice || 0),
        disponivel: true,
        disponivelParaDelivery: true,
        disponivelNaMesa: true,
        produto: {id: idProduto},
        idProduto
      };
      const linkImagem = produto.raw?.imagens?.[0]?.linkImagem;
      if (linkImagem) opcaoRaw.linkImagem = linkImagem;

      this.groupDraft.name = 'Sugestão de cross-sell';
      this.groupDraft.type = 'single';
      this.groupDraft.required = false;
      this.groupDraft.min = 0;
      this.groupDraft.max = 1;
      this.groupDraft.multiplicaQuantidadeProduto = false;
      this.groupDraft.raw = {combo: true, opcoesDisponiveis: [opcaoRaw]};
      this.groupDraft.options = [{
        id: null,
        name: produto.name,
        description: produto.description || '',
        price: Number(produto.basePrice || 0),
        active: true,
        disponivelParaDelivery: true,
        disponivelNaMesa: true,
        order: 0,
        linkImagem: linkImagem || null,
        raw: opcaoRaw
      }];
      this.creationPhase = 'full';
      this.wizardMode = 'create';
      this.checkDirty();
      this.emitActionBarState();
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível pré-preencher a sugestão de cross-sell.');
    }
  }

  private cloneGroup(grupo: ChoiceGroupVM): ChoiceGroupVM {
    return JSON.parse(JSON.stringify(grupo));
  }

  private getSharedWarningSupportText(): string {
    if (this.sharedProductNames.length > 0) {
      const maxShow = 5;
      const names = this.sharedProductNames.slice(0, maxShow).join(', ');
      const extra = this.sharedProductNames.length > maxShow
        ? ` +${this.sharedProductNames.length - maxShow} mais`
        : '';
      return `Usado em: ${names}${extra}`;
    }
    const sharedCount = Number(this.groupDraft?.sharedCount || 0);
    if (sharedCount > 1) {
      return `Em uso em ${sharedCount} produtos.`;
    }
    return 'Editar aqui afeta outros produtos.';
  }

  private async loadSharedProductNames(): Promise<void> {
    if (!this.groupDraft?.id || !this.empresa?.catalogo) return;
    try {
      this.sharedProductNames = await this.facade.carregueNomesProdutosDoAdicional(
        this.empresa.catalogo,
        this.groupDraft.id
      );
      if (this.sharedProductNames.length > 1 && this.groupDraft) {
        this.groupDraft.shared = true;
        this.groupDraft.sharedCount = this.sharedProductNames.length;
      }
    } catch {
      this.sharedProductNames = [];
    }
  }

  private resetSectionExpansion(): void {
    this.sectionExpanded = {
      identity: true,
      rules: true,
      quantity: true,
      options: true,
      summary: false
    };
  }

  private getTypeLabel(type?: string | null): string {
    if (type === 'kit') return 'Composição do kit';
    if (type === 'multipleRepeat') return 'Múltipla c/ rep.';
    if (type === 'multiple') return 'Múltipla';
    return 'Única';
  }

  private getChargeTypeLabel(type?: string | null): string {
    if (type === 'media') return 'Média';
    if (type === 'maior') return 'Maior';
    return 'Soma';
  }

  getQuantityModeTitle(multiplica = true): string {
    return multiplica
      ? 'Por unidade do produto'
      : 'Item complementar';
  }

  getQuantityModeDescription(multiplica = true): string {
    return multiplica
      ? 'Cada unidade do produto inclui este adicional.'
      : 'Aparece uma vez no pedido, independente da quantidade. Ideal para sugerir itens que combinam.';
  }

  getQuantityModeExample(multiplica = true): string {
    return multiplica
      ? '3 marmitas + arroz branco = 3x arroz branco'
      : '3 marmitas + 1 refrigerante = 1 refrigerante';
  }

  getQuantityModeChip(multiplica?: boolean | null): string {
    return multiplica === false ? 'Item complementar' : 'Por unidade do produto';
  }

  private takeSnapshot(): void {
    this.snapshot = JSON.stringify(this.groupDraft);
  }

  // ────────────────────────────── Dirty State ──────────────────────────────

  checkDirty(): void {
    const currentState = JSON.stringify(this.groupDraft);
    this.isDirty = currentState !== this.snapshot;

    if (this.creationPhase !== 'full' || this.mode === 'create') {
      this.saveFooterState = 'hidden';
      this.emitActionBarState();
      return;
    }

    if (this.isDirty && this.saveFooterState !== 'saving') {
      this.saveFooterState = 'dirty';
    } else if (!this.isDirty && this.saveFooterState === 'dirty') {
      this.saveFooterState = 'hidden';
    }

    this.emitActionBarState();
  }

  onFieldChange(): void {
    if (!this.podeEditar) return;
    this.clearResolvedDraftErrors();
    this.checkDirty();
  }

  // ── Validação inline (a página é única; nada de "preencha para continuar") ──

  private validateDraft(): AdicionalDraftErrors {
    const errors: AdicionalDraftErrors = {};

    if (!this.groupDraft?.name?.trim()) {
      errors.name = 'Dê um nome ao adicional — é o título que o cliente vê no cardápio.';
    }

    if (!this.hasOptions) {
      errors.options = 'Adicione pelo menos 1 opção para o cliente escolher.';
    }

    return errors;
  }

  /** Marca os erros e leva o operador ao primeiro campo pendente. Devolve se está válido. */
  private checkDraftBeforeSave(): boolean {
    this.creationErrors = this.validateDraft();

    if (this.creationErrors.name) {
      this.sectionExpanded.identity = true;
      this.focusDraftField('name');
      return false;
    }

    if (this.creationErrors.options) {
      this.sectionExpanded.options = true;
      this.focusDraftField('options');
      return false;
    }

    return true;
  }

  private clearResolvedDraftErrors(): void {
    if (!this.creationErrors.name && !this.creationErrors.options) return;
    const atual = this.validateDraft();
    this.creationErrors = {
      name: atual.name ? this.creationErrors.name : undefined,
      options: atual.options ? this.creationErrors.options : undefined
    };
  }

  private focusDraftField(field: keyof AdicionalDraftErrors): void {
    setTimeout(() => {
      const host: HTMLElement | null = this.elementRef?.nativeElement;
      const alvo = host?.querySelector<HTMLElement>(`[data-draft-field="${field}"]`);
      if (!alvo) return;
      alvo.scrollIntoView({ block: 'center', behavior: 'smooth' });
      alvo.querySelector<HTMLElement>('input, [tabindex], button')?.focus();
    });
  }

  adicionarQuantidadeComponente(): void {
    if (!this.podeEditar || !this.groupDraft?.raw?.configComponenteKit) return;
    const config = this.groupDraft.raw.configComponenteKit;
    config.quantidades = config.quantidades || [];
    config.quantidades.push({descricao: '', qtdeUnidades: 100, preco: 0, disponivel: true});
    this.onFieldChange();
  }

  removerQuantidadeComponente(indice: number): void {
    const config = this.groupDraft?.raw?.configComponenteKit;
    if (!this.podeEditar || !config?.quantidades) return;
    config.quantidades.splice(indice, 1);
    this.onFieldChange();
  }

  alterarModalidadeComponente(config: ConfigComponenteKit, modalidade: ConfigComponenteKit['modalidadeQuantidade']): void {
    if (!this.podeEditar || !config || config.modalidadeQuantidade === modalidade) return;
    config.modalidadeQuantidade = modalidade;
    if (modalidade === 'FECHADA' && !(config.quantidades || []).length) {
      config.quantidades = config.quantidades || [];
      config.quantidades.push({descricao: 'Cento', qtdeUnidades: config.qtdeFixa || 100, preco: 0, disponivel: true} as QuantidadeComponenteKit);
    }
    this.onFieldChange();
  }

  // Frases curtas que a prévia do card de composição mostra: o que o cliente vai
  // ver na loja, com os números que o lojista acabou de digitar.
  obtenhaPreviaComponenteKit(config: ConfigComponenteKit): string[] {
    if (!config) return [];
    const moeda = (v: number) => Number(v || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    const un = (n: number) => `${Number(n || 0)} un.`;
    const linhas: string[] = [];
    const cobraPorQtde = config.cobranca === 'POR_QUANTIDADE';

    if (config.modalidadeQuantidade === 'FIXA') {
      linhas.push(`Cada kit leva ${un(config.qtdeFixa)} deste grupo` + (cobraPorQtde && config.preco > 0 ? `, cobradas a ${moeda(config.preco)} por kit.` : '.'));
    } else if (config.modalidadeQuantidade === 'FECHADA') {
      const disponiveis = (config.quantidades || []).filter(q => q.disponivel !== false && q.qtdeUnidades > 0);
      if (!disponiveis.length) {
        linhas.push('Cadastre ao menos uma quantidade disponível para o cliente escolher.');
      } else {
        linhas.push('Cliente escolhe entre: ' + disponiveis.map(q =>
          `${q.descricao || un(q.qtdeUnidades)}${q.descricao ? ' (' + un(q.qtdeUnidades) + ')' : ''}${cobraPorQtde ? ' ' + moeda(q.preco) : ''}`).join(' · ') + '.');
      }
    } else {
      const min = Number(config.qtdeMinima || 0), max = Number(config.qtdeMaxima || 0), passo = Number(config.incremento || 0);
      linhas.push(`Cliente escolhe de ${un(min)}` + (max > 0 ? ` a ${un(max)}` : ' em diante') + (passo > 0 ? `, de ${passo} em ${passo}` : '') + '.');
      if (cobraPorQtde) {
        const ref = Number(config.qtdeReferencia || 0), preco = Number(config.precoReferencia || 0);
        if (ref > 0 && preco > 0) {
          const exemplo = passo > 0 ? min + 2 * passo : min;
          const dentroDoTeto = !(max > 0) || exemplo <= max;
          linhas.push(`${moeda(preco)} por ${un(ref)}` + (dentroDoTeto && exemplo !== ref ? ` — ex.: ${un(exemplo)} saem por ${moeda(preco * exemplo / ref)}.` : '.'));
        } else {
          linhas.push('Informe o preço de referência e para quantas unidades ele vale.');
        }
      }
    }

    const minPorOpcao = Number(config.qtdeMinimaPorOpcao || 0), maxOpcoes = Number(config.qtdeMaximaDeOpcoes || 0);
    let distribuicao = minPorOpcao > 1 ? `Pelo menos ${un(minPorOpcao)} de cada opção escolhida` : 'Qualquer quantidade por opção escolhida';
    if (maxOpcoes > 0) distribuicao += `, em até ${maxOpcoes} ${maxOpcoes === 1 ? 'opção' : 'opções diferentes'}`;
    linhas.push(distribuicao + '.');
    if (!cobraPorQtde) linhas.push('Sem cobrança extra por este grupo: já está no preço do kit.');
    return linhas;
  }

  onGroupTypeChange(type: ChoiceGroupVM['type']): void {
    if (!this.groupDraft || !this.podeEditar) return;
    if (type === 'kit' && this.editor?.type !== 'kit') return;
    if (this.groupDraft.raw?.id && (type === 'kit') !== (this.groupDraft.raw.tipo === 'componente-kit')) {
      this.notificationService.showError('Crie ou duplique um grupo para mudar entre adicional comum e composição do kit.'); return;
    }
    this.groupDraft.type = type;
    if (type === 'kit') {
      this.groupDraft.raw = this.groupDraft.raw || {};
      this.groupDraft.raw.configComponenteKit = this.groupDraft.raw.configComponenteKit || new ConfigComponenteKit();
      this.groupDraft.required = true; this.groupDraft.chargeType = 'soma'; this.groupDraft.multiplicaQuantidadeProduto = true;
    }
    if (type === 'single') {
      this.groupDraft.min = this.groupDraft.min > 0 ? 1 : 0;
      this.groupDraft.max = 1;
      this.groupDraft.required = this.groupDraft.min > 0;
    }
    this.checkDirty();
  }

  onRequiredChange(required: boolean): void {
    if (!this.groupDraft || !this.podeEditar) return;
    this.groupDraft.min = required ? Math.max(1, Number(this.groupDraft.min || 0)) : 0;
    this.groupDraft.required = this.groupDraft.min > 0;
    if (this.groupDraft.type === 'single') {
      this.groupDraft.min = required ? 1 : 0;
      this.groupDraft.max = 1;
    }
    if (this.groupDraft.max < this.groupDraft.min) {
      this.groupDraft.max = this.groupDraft.min;
    }
    this.checkDirty();
  }

  onMinimumChange(value: number): void {
    if (!this.groupDraft || !this.podeEditar) return;
    const min = this.groupDraft.type === 'single'
      ? (Number(value || 0) > 0 ? 1 : 0)
      : Math.max(0, Number(value || 0));
    this.groupDraft.min = min;
    this.groupDraft.required = min > 0;
    if (this.groupDraft.max < min) {
      this.groupDraft.max = min;
    }
    this.checkDirty();
  }

  onMaximumChange(value: number): void {
    if (!this.groupDraft || !this.podeEditar) return;
    this.groupDraft.max = this.groupDraft.type === 'single'
      ? 1
      : Math.max(this.groupDraft.min, Number(value || 1));
    this.checkDirty();
  }

  isSectionExpanded(section: AdicionalSectionKey): boolean {
    return !!this.sectionExpanded[section];
  }

  toggleSection(section: AdicionalSectionKey): void {
    this.sectionExpanded[section] = !this.sectionExpanded[section];
  }

  // ────────────────────────────── Save / Cancel ──────────────────────────────

  async onSave(): Promise<void> {
    if (!this.podeEditar) {
      this.notificationService.showError('A estrutura do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft || !this.editor) return;
    if (this.erroLimiteAdicionais) {
      this.notificationService.showError(this.erroLimiteAdicionais);
      return;
    }
    if (!this.checkDraftBeforeSave()) return;

    // O save explícito grava tudo; o que estava no debounce viraria duplicata.
    if (this.groupSaveTimer) {
      clearTimeout(this.groupSaveTimer);
      this.groupSaveTimer = null;
    }

    try {
      this.saveFooterState = 'saving';
      this.emitActionBarState();

      if (!this.editor.raw?.id) {
        this.notificationService.showError('Salve o produto antes de salvar o adicional.');
        this.saveFooterState = 'dirty';
        this.emitActionBarState();
        return;
      }

      this.groupDraft.description = this.describeDraft(this.groupDraft);

      await this.facade.salveGrupo(this.empresa.catalogo, this.editor.raw, this.groupDraft,
        this.podeEditarExibicaoOpcoes);

      if (this.groupDraft.kind === 'adicional' && this.groupDraft.raw) {
        this.editor.raw.camposAdicionais = this.editor.raw.camposAdicionais || [];
        const existing = (this.editor.raw.camposAdicionais || []).find((item: any) => item.id === this.groupDraft!.raw?.id);
        if (!existing) {
          this.editor.raw.camposAdicionais.push(this.groupDraft.raw);
        }
      }

      this.takeSnapshot();
      this.isDirty = false;
      this.creationErrors = {};
      this.saveFooterState = 'saved';
      this.emitActionBarState();
      this.groupSaved.emit(this.groupDraft);

      if (this.savedTimer) clearTimeout(this.savedTimer);
      this.savedTimer = setTimeout(() => {
        this.saveFooterState = 'hidden';
        this.emitActionBarState();
      }, 2000);
    } catch (error: any) {
      this.saveFooterState = 'dirty';
      this.emitActionBarState();
      this.notificationService.showError(error?.message || error || 'Não foi possível salvar o adicional.');
    }
  }

  async onSaveAndClose(): Promise<void> {
    await this.onSave();
    if (this.saveFooterState === 'saved') {
      this.closeRequested.emit();
    }
  }

  onCancel(): void {
    if (!this.snapshot) return;
    this.groupDraft = JSON.parse(this.snapshot);
    this.isDirty = false;
    this.saveFooterState = 'hidden';
    this.emitActionBarState();
  }

  // ────────────────────────────── Delete ──────────────────────────────

  requestDelete(): void {
    if (!this.podeEditar) {
      this.notificationService.showError('A exclusão do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }
    this.showDeleteDialog = true;
  }

  cancelDelete(): void {
    this.showDeleteDialog = false;
  }

  async confirmDelete(): Promise<void> {
    if (!this.podeEditar) {
      this.notificationService.showError('A exclusão do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft || !this.editor) return;

    try {
      this.showDeleteDialog = false;
      await this.facade.removaGrupo(this.editor.raw, this.empresa.catalogo, this.groupDraft);
      this.editor.raw.camposAdicionais = (this.editor.raw.camposAdicionais || [])
        .filter((item: any) => item.id !== this.groupDraft!.raw?.id);
      this.groupDeleted.emit(this.groupDraft);
      this.notificationService.showSuccess(this.groupDraft.shared ? 'Adicional removido deste produto.' : 'Adicional excluído.');
      this.closeRequested.emit();
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível excluir o adicional.');
    }
  }

  // ────────────────────────────── Option Modes ──────────────────────────────

  setOptionMode(mode: AdicionalOptionModeV2): void {
    if (mode === 'review' && !this.podeEditarAlgumaOpcao) return;
    if (mode === 'activation' && !this.podeEditarDisponibilidade) return;
    if (mode === 'batch-price' && !this.podeEditarPrecos) return;
    const previousMode = this.optionMode;
    this.optionMode = mode;
    if (previousMode === 'batch-price' && mode !== 'batch-price') {
      this.clearBatchSelection();
      this.closeBatchSheet();
    }
    if (previousMode !== 'batch-price' && mode === 'batch-price') {
      this.preselectFilteredBatchOptions();
    }
    if (mode !== 'review') {
      this.editSheetOpen = false;
      this.commitEditingOption();
    }
  }

  setOptionSearch(value: string): void {
    this.optionSearch = value;
  }

  setOptionSort(sort: AdicionalOptionSortV2): void {
    this.optionSort = sort;
  }

  // ────────────────────────────── Add Option ──────────────────────────────

  addOptionFromInput(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.addingOption) {
      return;
    }
    if (!this.podeEditar) {
      this.notificationService.showError('A inclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft) return;

    const name = this.newOptionName.trim();
    if (!name) return;

    this.addingOption = true;

    const price = this.parseOptionMoney(this.newOptionPrice);

    const hadNoOptions = this.groupDraft.options.length === 0;

    const option: ChoiceOptionVM = {
      id: null,
      name,
      price,
      active: true,
      disponivelParaDelivery: true,
      disponivelNaMesa: true,
      order: this.groupDraft.options.length,
      raw: {
        nome: name,
        valor: price,
        disponivel: true,
        disponivelParaDelivery: true,
        disponivelNaMesa: true,
        nova: true
      }
    };

    this.groupDraft.options.push(option);
    if (!this.groupDraft.raw) {
      this.groupDraft.raw = {};
    }
    if (!this.groupDraft.raw.opcoesDisponiveis) {
      this.groupDraft.raw.opcoesDisponiveis = [];
    }
    this.groupDraft.raw.opcoesDisponiveis.push(option.raw);

    this.newOptionName = '';
    this.newOptionPrice = '';
    if (hadNoOptions) {
      this.sectionExpanded.options = true;
    }
    this.clearResolvedDraftErrors();
    this.checkDirty();

    if (this.mode === 'edit') {
      this.scheduleAutoSave();
    }

    queueMicrotask(() => {
      this.addingOption = false;
    });
  }

  // ────────────────────────────── Chip Actions ──────────────────────────────

  onChipClickOnOff(option: ChoiceOptionVM): void {
    if (!this.podeEditarDisponibilidade) {
      this.notificationService.showError('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }
    option.active = !option.active;
    this.syncOptionToRaw(option);
    this.checkDirty();
    if (this.mode === 'edit') {
      this.scheduleAutoSave();
    }
  }

  onChipClickEditar(option: ChoiceOptionVM): void {
    if (!this.podeEditarAlgumaOpcao) {
      this.notificationService.showError('A edição das opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    this.editingOptionId = option.id ?? option.name;
    this.editingOptionName = option.name;
    this.editingOptionPrice = option.price;
    this.editingOptionPdv = option.codigoPdv || '';
    this.editingOptionDescription = option.description || '';
    this.editingOptionActive = option.active !== false;
    this.editingOptionLinkImagem = option.linkImagem || null;
    this.editingOptionQtdeMaxima = option.qtdeMaxima ?? null;
    this.editingOptionDisponivelParaDelivery = option.disponivelParaDelivery !== false;
    this.editingOptionDisponivelNaMesa = option.disponivelNaMesa !== false;
    this.editSheetAdvancedOpen = !this.isMobile || this.hasAdvancedOptionData();
    this.editSheetActiveTab = 'dados';
    this.editSheetOpen = true;
    setTimeout(() => this.editingOptionNameInput?.nativeElement.focus({ preventScroll: true }));
  }

  onChipClickLote(option: ChoiceOptionVM): void {
    if (!this.podeEditarPrecos) {
      this.notificationService.showError('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }
    this.toggleBatchOption(option);
  }

  isEditingOption(option: ChoiceOptionVM): boolean {
    return this.editingOptionId === (option.id ?? option.name);
  }

  // ────────────────────────────── Edit Sheet ──────────────────────────────

  closeEditSheet(): void {
    this.editSheetOpen = false;
    this.editingOptionId = null;
    this.editSheetActiveTab = 'dados';
    this.editingOptionName = '';
    this.editingOptionPrice = null;
    this.editingOptionPdv = '';
    this.editingOptionDescription = '';
    this.editingOptionActive = true;
    this.editingOptionLinkImagem = null;
    this.editingOptionQtdeMaxima = null;
    this.editingOptionDisponivelParaDelivery = true;
    this.editingOptionDisponivelNaMesa = true;
    this.editingOptionUploadingImage = false;
    this.editSheetAdvancedOpen = false;
  }

  // Descrição saiu das avançadas (fica sempre visível), então não conta mais aqui.
  hasAdvancedOptionData(): boolean {
    return !!(this.editingOptionLinkImagem || this.editingOptionQtdeMaxima ||
      !this.editingOptionDisponivelParaDelivery || !this.editingOptionDisponivelNaMesa);
  }

  saveAndCloseEditSheet(): void {
    if (this.editingOptionUploadingImage) return;
    if (!this.podeEditarAlgumaOpcao) {
      this.closeEditSheet();
      return;
    }
    this.commitEditingOption();
    this.editSheetOpen = false;
  }

  deleteAndCloseEditSheet(): void {
    if (!this.podeEditar) {
      this.notificationService.showError('A exclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft) return;
    const option = this.groupDraft.options.find(
      (o) => (o.id ?? o.name) === this.editingOptionId
    );
    if (option) {
      this.removeOption(option);
    }
    this.closeEditSheet();
  }

  private commitEditingOption(): void {
    if (this.editingOptionId == null || !this.groupDraft) return;
    const option = this.groupDraft.options.find(
      (o) => (o.id ?? o.name) === this.editingOptionId
    );
    if (option) {
      let changed = false;

      if (this.podeEditar) {
        option.name = this.editingOptionName;
        option.codigoPdv = this.editingOptionPdv || '';
        option.description = this.editingOptionDescription;
        if (option.linkImagem !== this.editingOptionLinkImagem) option.imagemQuebrada = false;
        option.linkImagem = this.editingOptionLinkImagem;
        option.qtdeMaxima = this.editingOptionQtdeMaxima;
        changed = true;
      }

      if (this.podeEditarPrecos) {
        option.price = this.editingOptionPrice ?? 0;
        changed = true;
      }

      if (this.podeEditarDisponibilidade && option.active !== this.editingOptionActive) {
        option.active = this.editingOptionActive;
        changed = true;
      }

      if (this.podeEditarExibicaoOpcoes) {
        option.disponivelParaDelivery = this.editingOptionDisponivelParaDelivery;
        option.disponivelNaMesa = this.editingOptionDisponivelNaMesa;
        changed = true;
      }

      if (changed) {
        this.syncOptionToRaw(option);
        this.checkDirty();
        if (this.mode === 'edit') {
          this.scheduleAutoSave();
        }
      }
    }
    this.editingOptionId = null;
    this.editingOptionName = '';
    this.editingOptionPrice = null;
    this.editingOptionPdv = '';
    this.editingOptionDescription = '';
    this.editingOptionActive = true;
    this.editingOptionLinkImagem = null;
    this.editingOptionQtdeMaxima = null;
    this.editingOptionDisponivelParaDelivery = true;
    this.editingOptionDisponivelNaMesa = true;
  }

  // ────────────────────────────── Batch ──────────────────────────────

  isBatchOptionSelected(option: ChoiceOptionVM): boolean {
    return !!this.batchSelection[this.getOptionRuntimeKey(option)];
  }

  toggleBatchOption(option: ChoiceOptionVM): void {
    const key = this.getOptionRuntimeKey(option);
    if (this.batchSelection[key]) {
      delete this.batchSelection[key];
    } else {
      this.batchSelection[key] = true;
    }
  }

  selectAllFilteredBatchOptions(): void {
    if (!this.podeEditarPrecos) return;
    this.filteredOptions.forEach((option) => {
      this.batchSelection[this.getOptionRuntimeKey(option)] = true;
    });
  }

  private preselectFilteredBatchOptions(): void {
    this.selectAllFilteredBatchOptions();
  }

  clearBatchSelection(): void {
    this.batchSelection = {};
  }

  openBatchSheet(): void {
    if (!this.podeEditarPrecos) {
      this.notificationService.showError('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }
    if (!this.batchSelectedCount) {
      this.notificationService.showError('Selecione pelo menos uma opção antes de alterar o preço.');
      return;
    }
    this.batchSheetOpen = true;
    this.batchAdjustMode = 'increment';
    this.batchAdjustDirection = 'increase';
    this.batchAdjustValue = '';
  }

  closeBatchSheet(): void {
    this.batchSheetOpen = false;
    this.batchAdjustDirection = 'increase';
    this.batchAdjustValue = '';
  }

  setBatchAdjustMode(mode: BatchPriceAdjustMode): void {
    this.batchAdjustMode = mode;
    this.batchAdjustDirection = 'increase';
    this.batchAdjustValue = '';
  }

  setBatchAdjustDirection(direction: BatchPriceAdjustDirection): void {
    this.batchAdjustDirection = direction;
  }

  getBatchModeCardTitle(mode: BatchPriceAdjustMode): string {
    switch (mode) {
      case 'increment':
        return 'Somar ou subtrair';
      case 'percent':
        return 'Aplicar percentual';
      case 'fixed':
      default:
        return 'Definir valor fixo';
    }
  }

  getBatchModeCardSymbol(mode: BatchPriceAdjustMode): string {
    switch (mode) {
      case 'increment':
        return '+/-';
      case 'percent':
        return '%';
      case 'fixed':
      default:
        return 'Fixo';
    }
  }

  getBatchModeCardDescription(mode: BatchPriceAdjustMode): string {
    switch (mode) {
      case 'increment':
        return 'Soma ou subtrai do preço atual de cada opção.';
      case 'percent':
        return 'Reajusta cada opção por porcentagem sobre o valor atual.';
      case 'fixed':
      default:
        return 'Define um novo preço exato para todas as opções selecionadas.';
    }
  }

  getBatchPreviewPrice(option: ChoiceOptionVM): number | null {
    if (!this.hasBatchAdjustValue) return null;
    return this.computeAdjustedOptionPrice(option, Math.abs(this.parseOptionMoney(this.batchAdjustValue)), this.batchAdjustMode);
  }

  applyBatchAdjust(): void {
    if (!this.podeEditarPrecos) {
      this.notificationService.showError('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft || !this.batchSelectedCount) return;

    const rawValue = Math.abs(this.parseOptionMoney(this.batchAdjustValue));

    (this.groupDraft.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        const newPrice = this.computeAdjustedOptionPrice(option, rawValue, this.batchAdjustMode);
        option.price = newPrice;
        this.syncOptionToRaw(option);
      });

    this.closeBatchSheet();
    this.checkDirty();
    if (this.mode === 'edit') {
      this.scheduleAutoSave();
    }
    this.notificationService.showSuccess('Preço ajustado em lote.');
  }

  applyBatchAvailability(active: boolean): void {
    if (!this.podeEditarDisponibilidade) {
      this.notificationService.showError('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft || !this.batchSelectedCount) {
      this.notificationService.showError('Selecione pelo menos uma opção.');
      return;
    }

    (this.groupDraft.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        option.active = active;
        this.syncOptionToRaw(option);
      });

    this.checkDirty();
    if (this.mode === 'edit') {
      this.scheduleAutoSave();
    }
    this.notificationService.showSuccess(active ? 'Opções ativadas em lote.' : 'Opções desativadas em lote.');
  }

  // ────────────────────────────── Helpers ──────────────────────────────

  trackByOption(index: number, option: ChoiceOptionVM): any {
    return option.id || index;
  }

  dismissEditHint(): void {
    this.showEditHint = false;
  }

  async goBack(): Promise<void> {
    await this.flushPendingSave();
    this.closeRequested.emit();
  }

  async enterLibraryMode(): Promise<void> {
    if (!this.podeEditar) {
      this.notificationService.showError('A biblioteca está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.wizardMode = 'library';
    this.creationPhase = 'config';
    await this.loadLibrary();
  }

  async openLibrary(): Promise<void> {
    await this.enterLibraryMode();
  }

  // Um clique resolve: o cartão é o botão, sem passo de "Selecionar + Continuar".
  selectChoice(selection: 'create' | 'library'): void {
    this.choiceSelection = selection;
    if (selection === 'library') {
      void this.enterLibraryMode();
      return;
    }
    this.enterCreateMode();
  }

  private enterCreateMode(): void {
    this.wizardMode = 'create';
    this.creationPhase = 'full';
    this.emitActionBarState();
  }

  /** A escolha "do zero / da biblioteca" só é um passo útil se houver biblioteca. */
  private async probeLibraryForChoice(): Promise<void> {
    this.choiceProbing = true;
    try {
      await this.loadLibrary();
    } finally {
      this.choiceProbing = false;
    }

    if (!this.isChoiceMode) return;
    if (this.libraryItems.length === 0) {
      this.choiceSelection = 'create';
      this.choiceSkipped = true;
      this.enterCreateMode();
    }
  }

  /**
   * Volta um nível: da biblioteca ou do formulário de criação para a escolha.
   * Quando a escolha foi pulada (biblioteca vazia, ou o chamador pediu criação
   * direta), não há para onde voltar dentro do editor — fecha.
   */
  async goBackFromWizard(): Promise<void> {
    await this.flushPendingSave();

    if (this.isLibraryMode || (this.mode === 'create' && !this.choiceSkipped)) {
      this.wizardMode = 'choice';
      this.creationPhase = 'config';
      this.emitActionBarState();
      return;
    }

    this.closeRequested.emit();
  }

  async onLibrarySearchChange(value: string): Promise<void> {
    this.librarySearch = value;
    if (value.trim()) {
      const groups = this.filteredLibraryProductGroups;
      for (const g of groups) {
        this.libraryExpandedProducts[g.productId] = true;
      }
    } else {
      this.libraryExpandedProducts = {};
    }
    await this.loadLibrary();
  }

  setLibraryFilter(filter: string): void {
    this.libraryFilter = filter;
    this.libraryExpandedProducts = {};
    if (this.selectedLibraryGroup && !this.filteredLibraryItems.some((item) => String(item.id) === String(this.selectedLibraryGroup?.id))) {
      this.selectedLibraryGroup = null;
      this.libraryMobilePreviewExpanded = false;
    }
  }

  selectLibraryGroup(group: LibraryGroupVM): void {
    this.selectedLibraryGroup = group;
    this.libraryHintMode = 'link';
  }

  toggleLibraryMobilePreview(): void {
    this.libraryMobilePreviewExpanded = !this.libraryMobilePreviewExpanded;
  }

  isLibraryGroupSelected(group: LibraryGroupVM): boolean {
    return !!this.librarySelection[String(group?.id ?? '')];
  }

  isLibraryGroupFocused(group: LibraryGroupVM): boolean {
    return String(this.selectedLibraryGroup?.id ?? '') === String(group?.id ?? '');
  }

  toggleLibraryGroupSelection(group: LibraryGroupVM): void {
    const key = String(group.id);
    this.librarySelection[key] = !this.librarySelection[key];
    this.selectedLibraryGroup = group;
    this.libraryHintMode = 'link';
  }

  isLibraryGroupLinked(item: LibraryGroupVM): boolean {
    if (!this.editor?.groups) return false;
    return this.editor.groups.some(g => String(g.id) === String(item.id));
  }

  setLibraryHintMode(mode: LibraryHintMode): void {
    this.libraryHintMode = mode;
  }

  async useLibraryGroup(group: LibraryGroupVM, clonar: boolean): Promise<void> {
    if (!this.podeEditar) {
      this.notificationService.showError('A biblioteca está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.editor) return;

    const persisted = await this.ensureProductPersisted();
    if (!persisted) return;

    try {
      await this.facade.vinculeGrupoDaBiblioteca(this.empresa.catalogo, this.editor.raw, group, clonar);
      this.notificationService.showSuccess(clonar ? 'Adicional duplicado da biblioteca.' : 'Adicional vinculado da biblioteca.');
      if (clonar) {
        this.groupDuplicated.emit();
      } else {
        this.libraryGroupsLinked.emit(1);
      }
    } catch (error: any) {
      this.notificationService.showError(error?.message || error || 'Não foi possível usar o adicional da biblioteca.');
    }
  }

  async linkSelectedLibraryGroups(): Promise<void> {
    if (!this.podeEditar || this.libraryLinking || !this.selectedLibraryCount || !this.editor) return;

    const persisted = await this.ensureProductPersisted();
    if (!persisted) return;

    const selected = [...this.selectedLibraryGroups];
    let linked = 0;
    this.libraryLinking = true;
    try {
      for (const group of selected) {
        await this.facade.vinculeGrupoDaBiblioteca(this.empresa.catalogo, this.editor.raw, group, false);
        linked += 1;
      }
      this.librarySelection = {};
      this.libraryGroupsLinked.emit(linked);
    } catch (error: any) {
      const prefix = linked > 0 ? `${linked} ${linked === 1 ? 'adicional foi vinculado' : 'adicionais foram vinculados'}. ` : '';
      this.notificationService.showError(prefix + (error?.message || error || 'Não foi possível concluir todos os vínculos.'));
      if (linked > 0) {
        this.libraryGroupsLinked.emit(linked);
      }
    } finally {
      this.libraryLinking = false;
    }
  }

  async duplicateFocusedLibraryGroup(): Promise<void> {
    if (!this.selectedLibraryGroup || this.libraryLinking) return;
    this.libraryHintMode = 'duplicate';
    await this.useLibraryGroup(this.selectedLibraryGroup, true);
  }

  private async loadLibrary(): Promise<void> {
    if (!this.empresa?.catalogo?.id) return;

    this.libraryLoading = true;
    try {
      this.libraryItems = await this.facade.carregueBiblioteca(this.empresa.catalogo, this.librarySearch, this.editor?.raw || this.editor || null);
      const availableIds = new Set(this.libraryItems.map((item) => String(item.id)));
      Object.keys(this.librarySelection).forEach((id) => {
        if (!availableIds.has(id)) delete this.librarySelection[id];
      });
      if (this.selectedLibraryGroup && !this.filteredLibraryItems.some((item) => String(item.id) === String(this.selectedLibraryGroup?.id))) {
        this.selectedLibraryGroup = null;
        this.libraryMobilePreviewExpanded = false;
      }
    } finally {
      this.libraryLoading = false;
    }
  }

  private async ensureProductPersisted(): Promise<boolean> {
    if (this.editor?.raw?.id) {
      this.editor.id = this.editor.raw.id;
      return true;
    }

    try {
      await this.facade.salveProduto(this.editor.raw);
      this.editor.id = this.editor.raw?.id || this.editor.id;
      return !!this.editor.raw?.id;
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Salve o produto antes de usar a biblioteca.');
      return false;
    }
  }

  // ────────────────────────────── Option Image ──────────────────────────────

  onOptionImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;

    this.editingOptionUploadingImage = true;
    const formData = new FormData();
    formData.append('image', file);

    this.httpClient.post<any>('/upload/imagens/crop/400', formData).subscribe(
      (response) => {
        const linkImagem = response?.data?.linkImagem;
        if (linkImagem) {
          this.editingOptionLinkImagem = linkImagem;
        } else {
          this.notificationService.showError('Erro ao fazer upload da imagem.');
        }
        this.editingOptionUploadingImage = false;
      },
      () => {
        this.notificationService.showError('Erro ao fazer upload da imagem.');
        this.editingOptionUploadingImage = false;
      }
    );

    input.value = '';
  }

  removeOptionImage(): void {
    this.editingOptionLinkImagem = null;
  }

  resolveOptionImageUrl(linkImagem: string): string {
    if (!linkImagem) return '';
    if (/^https?:\/\//i.test(linkImagem)) return linkImagem;
    return '/images/empresa/' + linkImagem.replace(/^\/+/, '');
  }

  hasOptionImage(option: ChoiceOptionVM): boolean {
    return !!option.linkImagem && !option.imagemQuebrada;
  }

  onOptionImageError(option: ChoiceOptionVM): void {
    option.imagemQuebrada = true;
  }

  private syncOptionToRaw(option: ChoiceOptionVM): void {
    if (!this.editor || !this.groupDraft) return;

    option.raw = option.raw || {};
    option.raw.nome = option.name;
    option.raw.codigoPdv = option.codigoPdv || '';
    option.raw.descricao = option.description || '';
    option.raw.linkImagem = option.linkImagem || null;
    option.raw.qtdeMaxima = option.qtdeMaxima ?? null;
    if (this.podeEditarExibicaoOpcoes || !option.raw.id) {
      option.raw.disponivelParaDelivery = option.disponivelParaDelivery !== false;
      option.raw.disponivelNaMesa = option.disponivelNaMesa !== false;
    }

    this.facade.apliqueEstadoOpcao(this.editor.raw, option.raw, {
      price: Number(option.price || 0),
      active: option.active
    });

    if (option.raw.id) {
      delete option.raw.nova;
      if (!option.raw.removida) {
        option.raw.atualizar = true;
      }
      return;
    }

    option.raw.nova = true;
    delete option.raw.atualizar;
  }

  private removeOption(option: ChoiceOptionVM): void {
    if (!this.podeEditar) {
      this.notificationService.showError('A exclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (!this.groupDraft) return;

    this.syncOptionToRaw(option);
    if (option.raw?.id) {
      option.raw.removida = true;
      delete option.raw.atualizar;
    } else if (this.groupDraft.raw?.opcoesDisponiveis) {
      this.groupDraft.raw.opcoesDisponiveis = this.groupDraft.raw.opcoesDisponiveis
        .filter((rawOption: any) => rawOption !== option.raw);
    }

    this.groupDraft.options = this.groupDraft.options.filter((item) => item !== option);
    this.checkDirty();
    if (this.mode === 'edit') {
      this.scheduleAutoSave();
    }
  }

  private getOptionRuntimeKey(option: ChoiceOptionVM): string {
    const existing = this.optionRuntimeKeys.get(option);
    if (existing) return existing;

    const key = option.id != null ? `option:${option.id}` : `draft:${++this.optionRuntimeKeySequence}`;
    this.optionRuntimeKeys.set(option, key);
    return key;
  }

  private describeDraft(grupo: ChoiceGroupVM): string {
    if (grupo.type === 'kit') {
      const c = grupo.raw.configComponenteKit;
      return `${c.modalidadeQuantidade === 'FIXA' ? c.qtdeFixa + ' unidades por kit' : 'Quantidade escolhida neste grupo'} · mínimo de ${c.qtdeMinimaPorOpcao} por opção${c.qtdeMaximaDeOpcoes ? ' · até ' + c.qtdeMaximaDeOpcoes + ' opções' : ''}`;
    }
    const descricaoBase = this.formatSelectionRule(grupo.type, grupo.required, grupo.min, grupo.max);
    return grupo.multiplicaQuantidadeProduto === false
      ? `${descricaoBase} • Item complementar`
      : descricaoBase;
  }

  private formatSelectionRule(type: ChoiceGroupVM['type'] | undefined, required: boolean, min: number, max: number): string {
    const normalizedMin = Math.max(0, Number(min || 0));
    const normalizedMax = Math.max(0, Number(max || 0));

    if (normalizedMin > 0 && normalizedMax > 0) {
      if (normalizedMin === normalizedMax) {
        return normalizedMax === 1 ? 'Selecione 1 opção' : `Selecione ${normalizedMax} opções`;
      }

      return `Selecione de ${normalizedMin} a ${normalizedMax} opções`;
    }

    if (normalizedMax > 0) {
      return normalizedMax === 1
        ? (required || type === 'single' ? 'Selecione 1 opção' : 'Selecione até 1 opção')
        : `Selecione até ${normalizedMax} opções`;
    }

    if (type === 'single') {
      return required ? 'Selecione 1 opção' : 'Selecione até 1 opção';
    }

    return required ? 'Selecione ao menos 1 opção' : 'Selecione opções';
  }

  private parseOptionMoney(value: string): number {
    const normalized = String(value || '0').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : 0;
  }

  private computeAdjustedOptionPrice(
    option: ChoiceOptionVM,
    rawValue: number,
    mode: BatchPriceAdjustMode
  ): number {
    switch (mode) {
      case 'increment': {
        const signedValue = this.batchAdjustDirection === 'decrease' ? -rawValue : rawValue;
        return Math.max(0, Number(option.price || 0) + signedValue);
      }
      case 'percent': {
        const signedValue = this.batchAdjustDirection === 'decrease' ? -rawValue : rawValue;
        const adjusted = Math.max(0, Number(option.price || 0) * (1 + signedValue / 100));
        return Math.round(adjusted * 100) / 100;
      }
      case 'fixed':
      default:
        return rawValue;
    }
  }

  private scheduleAutoSave(): void {
    if (this.groupSaveTimer) clearTimeout(this.groupSaveTimer);
    this.groupSaveTimer = setTimeout(() => {
      this.groupSaveTimer = null;
      void this.runAutoSave();
    }, 800);
  }

  /** Grava agora o que estava esperando o debounce. Chamado ao sair da tela. */
  async flushPendingSave(): Promise<void> {
    if (!this.groupSaveTimer) return;
    clearTimeout(this.groupSaveTimer);
    this.groupSaveTimer = null;
    await this.runAutoSave();
  }

  private async runAutoSave(): Promise<void> {
    if (!this.groupDraft || !this.editor) return;
    try {
      this.groupDraft.description = this.describeDraft(this.groupDraft);
      await this.facade.salveGrupo(this.empresa.catalogo, this.editor.raw, this.groupDraft,
        this.podeEditarExibicaoOpcoes);
      if (this.groupDraft.kind === 'adicional' && this.groupDraft.raw) {
        this.editor.raw.camposAdicionais = this.editor.raw.camposAdicionais || [];
        const exists = (this.editor.raw.camposAdicionais || []).find((item: any) => item.id === this.groupDraft!.raw?.id);
        if (!exists) {
          this.editor.raw.camposAdicionais.push(this.groupDraft.raw);
        }
      }
    } catch (error: any) {
      this.notificationService.showError(error?.message || error || 'Não foi possível salvar as opções do adicional.');
    }
  }
}
